import { useState } from 'react'

/**
 * Hook para manejar la apertura y cierre de un modal dinámico.
 * Permite definir un título y un componente a renderizar dentro del modal.
 *
 * @hook
 * @returns {Object} Modal state y funciones de control
 * @returns {boolean} returns.isOpen Indica si el modal está abierto
 * @returns {{title: string, component: import("react").ReactNode}} returns.modalConfig Configuración actual del modal
 * @returns {(title: string, component: import("react").ReactNode) => void} returns.openModal Abre el modal con un título y componente
 * @returns {() => void} returns.closeModal Cierra el modal
 */
const useModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const [isLargeModal, setIsLargeModal] = useState(false)

  /**
   * Configuración del modal
   * @type {[{title: string, component: import("react").ReactNode}, Function]}
   */
  const [modalConfig, setModalConfig] = useState({
    title: '',
    component: null,
  })

  /**
   * Abre el modal con un título y componente.
   *
   * @param {string} title Título del modal
   * @param {import("react").ReactNode} component Componente React que se renderizará dentro del modal
   */
  const openModal = (title, component) => {
    setModalConfig({ title, component })
    setIsOpen(true)
  }

  const openLargeModal = (title, component) => {
    openModal(title, component)
    setIsLargeModal(true)
  }

  /**
   * Cierra el modal.
   */
  const closeModal = () => {
    setIsOpen(false)
    setIsLargeModal(false)
  }

  return {
    isOpen,
    isLargeModal,
    modalConfig,
    openModal,
    openLargeModal,
    closeModal,
  }
}

export default useModal
